import React, { useEffect, useState } from 'react'
import Modal from 'antd/es/modal';
import StarFilled from '@ant-design/icons/lib/icons/StarFilled';

function RewardImages({ form, featuredImagePath, imagesPath }) {
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState([]);
    const [featuredImage, setFeaturedImage] = useState();

    useEffect(() => {
        setFeaturedImage(() => featuredImagePath)
    }, [featuredImagePath])

    useEffect(() => {
        const newFileList = imagesPath?.map(
            (url) => ({
                url,
                status: 'done'
            })
        )
        setFileList(() => newFileList)
    }, [imagesPath])

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = (file) => {
        setPreviewImage(file.url);
        setPreviewOpen(true);
    };

    return (
        <>
            <div className="ant-upload-list ant-upload-list-picture-card">
                {fileList?.map((file, index) => (
                    <div key={index} className="ant-upload-list-picture-card-container" style={{ width: 104, height: 104, margin: 0 }}>
                        <div className="ant-upload-list-item ant-upload-list-item-done">
                            <div style={{ position: "relative", height: "100%" }}>
                                <div style={{ height: "100%" }}>
                                    <img
                                        src={file.url}
                                        alt={`preview ${index}`}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            cursor: 'pointer',
                                            padding: 8,
                                            borderRadius: 8
                                        }}
                                        onClick={() => handlePreview(file)}
                                    />
                                </div>
                                <div style={{ position: "absolute", top: 10, zIndex: 10, left: 6 }}>
                                    {(featuredImage === file.url || (!featuredImage && index === 0)) && (
                                        <StarFilled style={{ color: 'gold', fontSize: '18px' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <Modal open={previewOpen} title='Image Preview' footer={null} onCancel={handleCancel}>
                <img
                    alt="preview"
                    style={{
                        width: '100%',
                    }}
                    src={previewImage}
                />
            </Modal>
        </>
    )
}

export default RewardImages